import { AddressValue } from './../../../shared/model/address-value';
import { Component, OnInit, ViewContainerRef, AfterViewChecked} from '@angular/core';
import { AutoEletricService } from '../../../shared/service/auto-eletric.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoEletric } from '../../../shared/model/auto-eletric';
import { Observable } from 'rxjs/Observable';
import { TakeMode } from '../../../shared/model/take-mode';
import { Technician } from '../../../shared/model/technician';
import { ProvidedServiceService } from '../../../shared/service/provided-service.service';
import { ProvidedService } from '../../../shared/model/provided-service';
import { Address } from '../../../shared/model/address';
import { CnpjPipe } from '../../../shared/pipe/cnpj.pipe';
import { CepPipe } from '../../../shared/pipe/cep.pipe';
import { AutoEletricProvidedService } from '../../../shared/model/auto-eletric-provided-service';
import { SaveHttpError } from '../../../shared/error/save-http-error';
import { UpdateHttpError } from '../../../shared/error/update-http-error';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { ToastService } from '../../../shared/service/toast.service';

declare var Materialize: any;

@Component({
  selector: 'auto-eletric-create-update',
  templateUrl: './auto-eletric-create-update.component.html',
  styleUrls: ['./auto-eletric-create-update.component.css']
})
export class AutoEletricCreateUpdateComponent implements OnInit, AfterViewChecked {
  hasDeliveryAddress = false;
  actionDeliveryLabel = 'ADICIONAR';
  newAutoEletric: AutoEletric;
  takeModes: Array<any>;
  providedServices: Array<ProvidedService>;
  partialTitle: string;
  private editMode = false;
  private autoEletricId: number;
  private cnpjPipe: CnpjPipe;
  private cepPipe: CepPipe;

  constructor(private _autoEletricService: AutoEletricService,
              private _providedServiceService: ProvidedServiceService,
              private _route: ActivatedRoute,
              private _router: Router,
              private _toastService: ToastService) {
    this.setEmptyAutoEletric();
    this.setPipes();
    this.editModeVerify();
    this.setUpObservers();
    this.findProvidedServices();
  }

  save() {
    if(!this.newAutoEletric.address.number.trim()){
      this.newAutoEletric.address.number = AddressValue.WITHOUT_NUMBER
    }

    if (this.editMode) {
      this._autoEletricService.update(this.newAutoEletric);
    } else {
      this._autoEletricService.save(this.newAutoEletric);
    }
  }

  editModeVerify() {
    this.partialTitle = 'Cadastrar ';
    this._route.params.subscribe(params => {
      if (params['id']) {
        this.editMode = true;
        this.autoEletricId = +params['id'];
        this._autoEletricService.findById(this.autoEletricId);
        this.partialTitle = 'Editar ';
      }
    });
  }

  setPipes() {
    this.cnpjPipe = new CnpjPipe();
    this.cepPipe = new CepPipe();
  }

  setEmptyAutoEletric() {
    this.newAutoEletric = new AutoEletric();
    this.newAutoEletric.address = new Address();
    this.setUpTechnicians();
    this.setUpAutoEletricServices();
    this.takeModes = new Array();
    this.removeDeliveryAddress();
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    try {
      Materialize.updateTextFields();
    } catch (e) { }
  }

  private setUpObservers() {
    this.setUpFindAction(this._autoEletricService.find$);
    this.setUpSaveUpdateAction(this._autoEletricService.save$);
    this.setUpSaveUpdateAction(this._autoEletricService.update$);
    this.setUpErrorAction(this._autoEletricService.error$);
    this.getTakeModes();
  }

  private setUpFindAction(observable) {
    observable
      .filter(autoEletric => autoEletric instanceof AutoEletric)
      .subscribe(
        (autoEletric: AutoEletric) => {
          this.newAutoEletric = autoEletric;
          if (this.newAutoEletric.deliveryAddress) {
            this.hasDeliveryAddress = true;
            this.actionDeliveryLabel = this.hasDeliveryAddress ? 'REMOVER' : 'ADICIONAR';
          }
        }
      );
  }

  private setUpErrorAction(observable) {
    observable
      .filter(error => error instanceof SaveHttpError || error instanceof UpdateHttpError)
      .subscribe(error => this._toastService.showMessage(error.text, 4000));
  }

  private setUpTechnicians() {
    this.newAutoEletric.technicians = new Array();
    this.addTechnician();
  }

  private setUpAutoEletricServices() {
    this.newAutoEletric.autoEletricServices = new Array();
    this.addProvidedService();
  }

  private setUpSaveUpdateAction(observable: Observable<AutoEletric>) {
    observable
      .subscribe(() => {
        this.goBack();
      });
  }

  getTakeModes() {
    this._autoEletricService.findAllTakeModes()
      .subscribe(
        takeModes => this.takeModes = this.takeModesValuesList(takeModes),
        error => {
          // Show message error on previous page
          this.goBack();
        }
      );
  }

  findProvidedServices() {
    this._providedServiceService.findAll()
      .subscribe(
        providedServices => this.providedServices = providedServices
      );
  }

  goBack() {
    this._router.navigate(['auto_eletrics/list']);
  }

  setTakeMode(value) {
    this.newAutoEletric.takeMode = value;
  }

  setAutoEletricAddressState(value) {
    this.newAutoEletric.address.state = value;
  }

  setAutoEletricDeliveryAddressState(value) {
    this.newAutoEletric.deliveryAddress.state = value;
  }

  addTechnician() {
    this.newAutoEletric.technicians.push(new Technician());
  }

  addProvidedService() {
    this.newAutoEletric.autoEletricServices.push(new AutoEletricProvidedService());
  }

  removeLastTechnician() {
    if (this.newAutoEletric.technicians.length > 1) {
      this.newAutoEletric.technicians = this.newAutoEletric.technicians.slice(0, -1);
    }
  }

  removeLastProvidedService() {
    if (this.newAutoEletric.autoEletricServices.length > 1) {
      this.newAutoEletric.autoEletricServices = this.newAutoEletric.autoEletricServices.slice(0, -1);
    }
  }

  takeModesValuesList(takeModes) {
    const takeModesList = [];
    Object.keys(takeModes).forEach(key => {
      takeModesList.push(new TakeMode(key, takeModes[key]));
    });
    return takeModesList;
  }

  getTakeModeFromKey(key) {
    return this.takeModes.find(takeMode => takeMode.key === key).value;
  }

  applyCnpjMask(event) {
    this.newAutoEletric.cnpj = this.cnpjPipe.transform(event.target.value, event.key);
  }

  applyCepMask(event) {
    return this.cepPipe.transform(event.target.value, event.key);
  }

  toggleDeliveryAddressForm() {
    this.hasDeliveryAddress = !this.hasDeliveryAddress;
    if (this.hasDeliveryAddress) {
      this.actionDeliveryLabel = 'REMOVER';
      this.addDeliveryAddress();
    } else {
      this.actionDeliveryLabel = 'ADICIONAR';
      this.removeDeliveryAddress();
    }
  }

  addDeliveryAddress() {
    this.newAutoEletric.deliveryAddress = new Address();
  }

  removeDeliveryAddress() {
    this.newAutoEletric.deliveryAddress = null;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/auto-eletric/component/auto-eletric-create-update/auto-eletric-create-update.component.ts